































import Component from 'vue-class-component';
import {Mixins, Prop} from 'vue-property-decorator';
import InputMixin from '@/components/input/InputMixin';
import CommonButton from '@/components/button/CommonButton.vue';
import IconButton from '@/components/button/IconButton.vue';

@Component({
    components: {CommonButton, IconButton},
    mixins: [InputMixin]
})
export default class MultiFileInput extends Mixins<InputMixin>(InputMixin) {
    @Prop({default: null}) private readonly maxFiles: number;
    @Prop({default: null}) private readonly uploadDrag: boolean;
    @Prop({
        default: () => {
            return [];
        }
    })
    protected readonly value: any[];
    @Prop({default: null}) protected readonly originValue: any;
    @Prop({default: null}) private readonly acceptPattern: string;
    @Prop({default: false}) private loading: boolean;
    @Prop({default: true}) private removeable: boolean;
    
    get files() {
        return this.value;
    }
    
    get limit() {
        return this.maxFiles;
    }

    get drag() {
        return this.uploadDrag;
    }

    get accept() {
        return this.acceptPattern;
    }
    
    get isLoading() {
        return this.loading;
    }
    
    get supplyRemove() {
        return this.removeable;
    }
    
    public onExceed(files: any, fileList: any[]) {
        const exceeds = [];
        for (let i = 0, length = files.length; i < length; i++) {
            exceeds.push({
                fileId: '',
                fileName: files[i].name,
                delFlag: 'N',
                appended: true,
                raw: files[i]
            });
        }
        
        const newFiles = [
            ...fileList,
            ...exceeds
        ];
        while (newFiles.length > this.limit) {
            newFiles.shift();
        }
        this.afterFileUploaded(newFiles);
    }
    
    public onChange(file: any, fileList: any[]) {
        file.fileName = file.name;

        const newFiles = [...fileList];
        newFiles.filter((newFile: any) => newFile.delFlag !== 'N' && newFile.delFlag !== 'Y')
                .forEach((added: any) => {
                    added.delFlag = 'N';
                    added.appended = true;
                });
        
        this.afterFileUploaded(newFiles);
    }

    public onRemove(index: number) {
        const newFiles = [
            ...this.value,
        ];

        if (newFiles[index].appended) {
            const value = newFiles.filter((item, itemIndex) => index !== itemIndex);
            this.$emit('input', value);
            this.syncToStore(value);
        } else {
            newFiles[index].delFlag = 'Y';
            this.$emit('input', newFiles);
            this.syncToStore(newFiles);
        }
    }
    
    public onRestore() {
        const value = [
            ...this.originValue,
        ];

        value.forEach((item: any) => item.delFlag = 'N');
        this.$emit('input', value);
        this.syncToStore(value);
    }

    private afterFileUploaded(newFiles: any) {
        this.commit();
        this.$emit('input', newFiles);
    }
    
    private syncToStore(value: any[]) {
        if (!this.hasDeleted() && this.hasNotAdded(value)) {
            this.rollback();
        } else {
            this.commit();
        }
    }
    
    private hasDeleted(): boolean {
        return this.originValue && this.originValue.find((origin: any, index: number) => {
            return origin.delFlag !== this.value[index].delFlag;
        });
    }
    
    private hasNotAdded(newFiles: any): boolean {
        if (this.originValue && this.originValue.length !== newFiles.length) {
            return false;
        }
        
        return newFiles.find((newFile: any, index: number) => {
            return this.originValue && newFile.uid !== this.originValue[index].uid;
        }) === undefined;
    }
    
    private commit() {
        if (this.changeDetectable) {
            this.$store.commit('commitValue', {
                itemId: this.getId,
                originValue: 'originFile',
                value: 'originFileChanged'
            });
        }
    }
    
    private rollback() {
        if (this.changeDetectable) {
            this.$store.commit('commitValue', {
                itemId: this.getId,
                originValue: 'init',
                value: 'init'
            });
        }
    }
}
